import { createAction, props } from "@ngrx/store";
import { Employee } from "../../models/employee";

//export const loadEmployeeAct = createAction('loadEmployeeEffect', props<{ page: number, pageSize: number}>());
//export const findAllPageableEmployeeAct  = createAction('findAllPageableEmployeeEffect', props<{ employees: Employee[], paginator: any }>());
export const loadEmployeeByIdAct = createAction('findEmployeeByIdEffect', props<{ employee : Employee }>());
export const findEmployeeAct = createAction('findEmployeeEffect', props<{ id: number }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );